module.exports = __webpack_public_path__ + "static/media/pp6.dfb6cee5.jpg";